// Module
var code = "<div class=\"wrapper space-between\">\n\t<div class=\"{{$.style['left-path']}}\">{{$.leftText}}</div>\n\t<div class=\"{{$.style['right-path']}}\">{{$.rightText}}</div>\n</div>";
// Exports
export default code;